export function normalizeApplicationType(value: string | null | undefined): string {
  const normalized = String(value || '').trim().toUpperCase();
  if (!normalized) return '';
  if (normalized === 'FCFC') return 'FCFS';
  return normalized;
}

export function displayApplicationType(value: string | null | undefined): string {
  return normalizeApplicationType(value) || '-';
}
